import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';
import { selectdigitalPrivateInfrastructuresQueryItems } from '../../../../../redux/digital-private-infrastructures/selector';
import { digitalPrivateInfrastructures } from '../../../../../redux/digital-private-infrastructures/action';
import DigitalPrivateInfrastructureComponent from '../components/digital-private-infrastructure-component';


let currentChange: any = {}
const DigitalPrivateInfrastructure= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectdigitalPrivateInfrastructuresQueryItems)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  
  
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedDigitalPrivateInfrastructure,
    setSelectedDigitalPrivateInfrastructure
  ] = useState<any>({
    MediaMappings: {
      MediaFiles: [],
      Templates: []
    }
  })
  const [
    digitalPrivateInfrastructureImageIndex,
    setDigitalPrivateInfrastructureImageIndex
  ] = useState<any>([])
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
 
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }


  const fetchDigitalPrivateInfrastructureById= ()=>{
    dispatch(digitalPrivateInfrastructures.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-private-infrastructures/query`,entity:'digitalPrivateInfrastructures',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDigitalPrivateInfrastructure({ ...selectedDigitalPrivateInfrastructure, [field]: event });
  }

  useEffect(
    () => {
     
      if (parmas?.id > 0) {
        fetchDigitalPrivateInfrastructureById()
        setIsLoading(false)
    }else {
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedDigitalPrivateInfrastructure(queryItems?.result?.items)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
        setMediaFiles(localSelectedMedia)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
        mediaFiles.length - 1,
        1
      )
      const updatedData = {
        ...selectedDigitalPrivateInfrastructure,
        MediaMappings: {MediaFiles: mediaFiles, Templates: selectedDigitalPrivateInfrastructure?.MediaMappings?.Templates},
    };
    if (parmas?.id > 0) {
      await dispatch(digitalPrivateInfrastructures.resetAction({ actionType: 'update' }))
      await  dispatch(digitalPrivateInfrastructures.update({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-private-infrastructures`,entity:'digitalPrivateInfrastructures',jsonData:{
          
    Records: [
      updatedData
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(digitalPrivateInfrastructures.resetAction({ actionType: 'create' }))
      await dispatch(digitalPrivateInfrastructures.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-private-infrastructures`,entity:'digitalPrivateInfrastructures',jsonData:{
          
      Records: [
        updatedData
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/management/dbaas/digital-private-infrastructures')
} 
const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 147,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }
  
    return localSelectedmedia
  }
  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setDigitalPrivateInfrastructureImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'digitalprivateinfrastructure',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {
  
    mediaFiles[digitalPrivateInfrastructureImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
    
  }
  
  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationInfo()
      }
    },
    [mediaFiles]
  )
  
    return (
    <>
     {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         ownerId={parmas?.id}
         />}
    {isLoading ? <PageLoader /> : 
          <DigitalPrivateInfrastructureComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedDigitalPrivateInfrastructure={selectedDigitalPrivateInfrastructure}
           back={back}
           handleFormSubmit={handleFormSubmit}
           changeImage={changeImage}
           mediaFiles={mediaFiles}
           handleFormItemChange={handleFormItemChange}

          />  
        }
    
          </>
    )
    
    }
   
    export default DigitalPrivateInfrastructure;
